import { Injectable, WritableSignal, computed, signal } from '@angular/core';

@Injectable()
export class BuilderStatusService {
  private readonly currentStatus: WritableSignal<{
    isPlaying: boolean;
    isPlayingPrev: boolean;
    isEditing: boolean;
  }> = signal({
    isPlaying: false,
    isPlayingPrev: false,
    isEditing: false,
  });

  readonly status = computed(() => this.currentStatus());

  togglePlaying() {
    this.currentStatus.update((val) => {
      return {
        ...val,
        isPlayingPrev: val.isPlaying,
        isPlaying: !val.isPlaying,
      };
    });
  }

  enableEditing() {
    this.currentStatus.update((val) => {
      return {
        ...val,
        isEditing: true,
      };
    });
  }

  disableEditing() {
    this.currentStatus.update((val) => {
      return {
        ...val,
        isEditing: false,
      };
    });
  }

  reset() {
    this.currentStatus.set({
      isPlaying: false,
      isPlayingPrev: false,
      isEditing: false,
    });
  }

  enableUpdating() {
    this.currentStatus.update((val) => {
      return {
        ...val,
        isUpdating: true,
      };
    });
  }
}
